import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { gql } from '../graphql/generated';
import useNavigate from '../utils/router/useNavigate';
import postPath from '../utils/url/postPath';

const DUPLICATE_POST_MUTATION = gql(/** @complexity 2 */ `
  mutation duplicatePost($id: ID!) {
    post: createPost(templateId: $id) {
      id
      shareSecret
      ...postPath_post
    }
  }
`);

const useDuplicatePost = () => {
  const [duplicatePost] = useMutation(DUPLICATE_POST_MUTATION);
  const navigate = useNavigate();

  return useCallback(
    async (postId: string) => {
      const response = await duplicatePost({ variables: { id: postId } });
      const newPost = response.data?.post;

      if (newPost) {
        navigate(
          postPath(newPost, { shareSecret: newPost.shareSecret ?? undefined }),
        );
      }
    },
    [duplicatePost, navigate],
  );
};

export default useDuplicatePost;
